import { render, staticRenderFns } from "./NavBarItem.vue?vue&type=template&id=529e6df5&scoped=true&"
import script from "./NavBarItem.vue?vue&type=script&lang=js&"
export * from "./NavBarItem.vue?vue&type=script&lang=js&"
import style0 from "./NavBarItem.vue?vue&type=style&index=0&id=529e6df5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529e6df5",
  null
  
)

export default component.exports